var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessThan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M370.312 117.656L79.812 256L370.312 394.344C382.281 400.031 387.375 414.344 381.656 426.312C377.562 434.969 368.938 440 359.969 440C356.531 440 353 439.25 349.687 437.656L13.687 277.656C5.312 273.688 0 265.25 0 256S5.312 238.312 13.688 234.344L349.688 74.344C361.625 68.594 376 73.719 381.656 85.688C387.375 97.656 382.281 111.969 370.312 117.656Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessThan);
export default __webpack_public_path__ + "static/media/less-than.03c856f7f9d9f11fd9d1265ce3ac1f3c.svg";
export { ForwardRef as ReactComponent };